import React from 'react';
// Zustand
import { useStore } from '../../zustand';
// Helpers
import { sendAnalyticsData } from "../../utility/handleAnalytics";
// Icons
import { ReactComponent as Rotate360 } from "../../assets/icons/rotate360.svg"
import { ReactComponent as ARLogo } from '../../assets/icons/ar_logo.svg';
import qrIcon from '../../assets/icons/qrCode-white.svg';
// Styles
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    buttonContainer: {
        display: 'flex',
        justifyContent: props => props.viewer_button.button_position,
        '& button': {
            ...theme.default_button,
            textTransform: 'uppercase',
            background: props => props.viewer_button.button_color,
            color: props => props.viewer_button.button_text_color,
            fontFamily: props => props.default_text_font,
            '& img': {
                maxWidth: '25px',
                marginLeft: '10px'
            },
            '& h3': {
                margin: 0,
                fontSize: '1rem',
                '& span': {
                    margin: 0,
                    display: 'block',
                    fontSize: '1.7rem'
                }
            }
        }
    },
    buttonContainer_billboards: {
        display: 'flex',
        justifyContent: props => props.viewer_button.button_position,
        '& button': {
            ...theme.default_button,
            textTransform: 'uppercase',
            //background: props => props.viewer_button.button_color,
            background: '#00344E', // Force override to remove branding
            color: props => props.viewer_button.button_text_color,
            fontFamily: props => props.default_text_font,
            flexDirection: 'column-reverse',
            fontSize: '1.5rem',
            '& img': {
                width: '100%',
                maxWidth: 125,
                marginLeft: 0,
                marginBottom: '.5rem',
            },
            '& h3': {
                margin: 0,
                fontSize: '1rem',
                '& span': {
                    margin: 0,
                    display: 'block',
                    fontSize: '1.7rem'
                }
            }
        }
    },
    button_container_tabs: {
        top: '100%',
        marginRight: '2rem',
        '& button': {
            ...theme.default_button,
            boxShadow: 'none',
            borderRadius: 12,
            justifyContent: 'center',
            //background: props => props.viewer_button.button_color,
            //background: '#00344E',
            //backgroundColor: 'transparent',
            //border: '1px solid #ccc',
            //color: props => props.viewer_button.button_text_color,
            color: '#ffffff',
            fontFamily: props => props.default_text_font,
            width: '100%',
            padding: '7px 0 0 22px',
            background: '#ececec',
            borderTopLeftRadius: 45,
            borderBottomLeftRadius: 45,
        },
        '& span': {
            color: 'rgba(0, 0, 0, 0.87) !important',
            fontSize: '0.95rem !important',
            fontWeight: '500 !important',
            marginTop: -3,

        },
    },
    button_ar_tabs: {
        width: 18, 
        marginTop: -4,
        //fill: props => props.viewer_button.button_color,
        fill: '#fff',
        position: 'relative',
        zIndex: 2,
    },
    tabs_icon_container: {
        position: 'relative',
        marginLeft: 18,
        '&::after': {
            content: `''`,
            position: 'absolute',
            width: 37,
            left: -10,
            top: -10,
            height: 34,
            background: '#00344E', // Force override to remove branding
            //background: props => props.viewer_button.button_color,
            zIndex: 1,
            display: 'block',
            borderRadius: '50%',
        }
    },
    iconContainer: {
        display: 'flex',
        '& button': {
            transition: 'all 0.5s ease',
            opacity: 1,
            padding: 0,
            border: 'none',
            outline: 'none',
            background: 'none',
            cursor: 'pointer',
            '&:hover': {
                opacity: .5
            },
        }
    },
    rotate_360_icon: {
        width: 60,
        '& .cls-1': {
            fill: '#bdbec0',
        },
    },
}));

export default function ViewSpaceBtn(props) {
    const { design } = props;
    const actions = useStore(state => state.actions);
    // const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const settings = useStore.getState().settings;
    const classes = useStyles(dynamic_text_settings);

    const openModal = async () => {
        actions.handleModalDisplay({ display: 'QRCodePrompt', status: true })
        await sendAnalyticsData({ event_type: 'qr_modal_open' });
    };
    
    if(settings.view_in_space_off) return null;

    switch(design) {
        case 'billboard':
            return (
                <div className={classes.buttonContainer_billboards}>
                    <button onClick={openModal}>
                        <h3><span>View In</span>Your Space</h3>
                        <img src={qrIcon} alt="View In My Space"/>
                    </button>
                </div>
            )
        case 'rotate_icon':
            return (
                <div className={classes.iconContainer}>
                    <button onClick={openModal}>
                        <Rotate360 className={classes.rotate_360_icon} />
                    </button>
                </div>
            )
        case 'tabs':
            return (
                <div className={classes.button_container_tabs}>
                    <button onClick={openModal}>
                        <span>My Space</span>
                        <div className={classes.tabs_icon_container}>
                            <ARLogo className={classes.button_ar_tabs} />
                        </div>
                    </button>
                </div>
            );
        default: 
            return (
                <div className={classes.buttonContainer}>
                    <button onClick={openModal}>
                        { 
                            dynamic_text_settings.viewer_button.button_text ? (
                                dynamic_text_settings.viewer_button.button_text) : (
                                    "View In My Space"
                                )
                        }
                        <img src={qrIcon} alt="View In My Space"/>
                    </button>
                </div>
            );
    }
}